var calculateProductPriceWithoutQuantity = function calculateProductPriceWithoutQuantity(productLineCost, quantity) {
  try {
    if (productLineCost === null || quantity === null) {
      return 0;
    }

    if (productLineCost === '' || quantity === '') {
      return 0;
    }

    return productLineCost / quantity;
  } catch (error) {
    console.log("calculateProductPriceWithoutQuantity - " + error);
    return 0;
  }
};

export default calculateProductPriceWithoutQuantity;